import { render, staticRenderFns } from "./HiddenRectificationView.vue?vue&type=template&id=2f4016f5&scoped=true"
import script from "./HiddenRectificationView.vue?vue&type=script&lang=js"
export * from "./HiddenRectificationView.vue?vue&type=script&lang=js"
import style0 from "./HiddenRectificationView.vue?vue&type=style&index=0&id=2f4016f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4016f5",
  null
  
)

export default component.exports